export default __webpack_public_path__ + "static/media/left_hover.9f2b679e.svg";